<template>
  <section class="c-card">

    <div class="c-card__header">
      <h2 class="c-card__header__title t-headline">{{ $t('web.catalog_category_list.header_title') }}</h2>
    </div>

    <div class="c-category-list">
      <template v-for="(category, i) in $store.getters.categories">
        <router-link
          v-if = "category.code"
          :key = "i"
          :to  = "{ name: 'Rewards Results', query: { category: category.code} }"
        >
          <category-list-tile :category="category"></category-list-tile>
        </router-link>

        <router-link
          v-if = "category.page_id"
          :key = "i"
          :to  = "{name: 'Page_' + category.page_id}"
        >
          <category-list-tile :category="category"></category-list-tile>
        </router-link>

        <router-link
          v-if = "category.reward_id"
          :key = "i"
          :to  = "{ name: 'Single Reward', params: { id: category.reward_id} }"
        >
          <category-list-tile :category="category"></category-list-tile>
        </router-link>

        <category-list-tile
          v-if = "!category.code && !category.page_id && !category.reward_id"
          :key      = "i"
          :category = "category"
          class     = "is-not-linked"
        ></category-list-tile>
      </template>
    </div>

  </section>
</template>




<script>
import CategoryListTile from './CategoryListTile'

export default {
  name: 'CategoryList',

  components: { CategoryListTile }
}
</script>



// WEBPACK FOOTER //
// CategoryList.vue?779c51f0